import styled from 'styled-components';
import { getSpacingToken, getTransition } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { BareIconButton } from '../BareIconButton';

interface ExpandButtonProps {
    expanded?: boolean;
}

export const ExpandButton = styled(BareIconButton).attrs({
    icon: IconName.ChevronDown,
})<ExpandButtonProps>`
    transform: ${(props) => (props.expanded ? 'rotate(180deg)' : 'none')};
    transition: ${getTransition()};
    padding: ${getSpacingToken('100')}px;
    box-sizing: content-box;
`;
